// @ts-strict-ignore
import React from "react";
import { Link } from "react-router-dom";

import PropTypes from "prop-types";
import PageContainer from "app/pages/AppDashboard/components/PageContainer/PageContainer";
import constants from "app/utils/constants";

import classes from "./styles.scss";

interface Props {
	isSideBarVisible?: boolean;
}

const Footer : React.FC<Props> = ({ isSideBarVisible }) => {
	const footerClasses = [classes.footerContainer];
	const currentYear = new Date().getFullYear();

	if (!isSideBarVisible) {
		footerClasses.push(classes.paddedContainer);
	}

	return (
		<div className={footerClasses.join(" ")}>
			<PageContainer>
				<div className={classes.dataContainer}>
					<Link
						to={{ pathname: "https://dcbyte.com/terms-of-service" }}
						target="_blank"
						rel="noopener noreferrer"
					>
						<span>Terms |</span>
					</Link>

					<Link
						to={{ pathname: "https://dcbyte.com/privacy" }}
						target="_blank"
						rel="noopener noreferrer"
					>
						<span>Privacy |</span>
					</Link>

					<Link
						to={{ pathname: "https://dcbyte.com/cookies-policy" }}
						target="_blank"
						rel="noopener noreferrer"
					>
						<span>Cookies</span>
					</Link>
				</div>

				<p>
					Registered Office. DC Byte Limited, Warden House, 37 Manor Road, Colchester, CO3 3LX, United Kingdom
				</p>

				<p>
					{constants.DCBYTE_FOOTER_VAT_TEXT}
				</p>

				<span className={classes.copyright}>Copyright © {currentYear} - DC Byte Limited.</span>
			</PageContainer>
		</div>
	);
};

Footer.propTypes = {
	isSideBarVisible: PropTypes.bool
};

export default Footer;
